import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type {
  ContractRequestDTO,
  ContractResponseDTO,
  ContractSearchParams,
} from "../types/contract.types";

export const contractAdminService = {
  search: async (
    params?: ContractSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<ContractResponseDTO>> => {
    const response = await api.get<PageResponseDTO<ContractResponseDTO>>(
      API_ENDPOINTS.CONTRACTS_ADMIN.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<ContractResponseDTO> => {
    const response = await api.get<ContractResponseDTO>(
      API_ENDPOINTS.CONTRACTS_ADMIN.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  create: async (
    data: ContractRequestDTO,
    options?: RequestOptions,
  ): Promise<ContractResponseDTO> => {
    const response = await api.post<ContractResponseDTO>(
      API_ENDPOINTS.CONTRACTS_ADMIN.BASE,
      data,
      { signal: options?.signal },
    );
    return response.data;
  },

  update: async (
    id: number,
    data: ContractRequestDTO,
  ): Promise<ContractResponseDTO> => {
    const response = await api.put<ContractResponseDTO>(
      API_ENDPOINTS.CONTRACTS_ADMIN.BY_ID(id),
      data,
    );
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.CONTRACTS_ADMIN.BY_ID(id));
  },
};
